import React from 'react';
import { useSortBy, useTable } from "react-table";
import { useColumns } from "../../../shared/components/Table/utils";
import Table from "../../../shared/components/Table";
import { NoResults } from "../../../shared/svg/Svg";
import { useReactAppState } from "../../../shared/containers/utils";

const PlayersRosterTable = ({ baseClass, emptyResultsComponent, playersData }) => {
  const { t } = useReactAppState();
  const columns = useColumns("PLAYERS_HUB_ROSTER", playersData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data: playersData && playersData.length > 0
        ? playersData
        : [],
      autoResetPage: true,
      autoResetSortBy: false,
      disableMultiSort: true,
      disableSortRemove: true,
      initialState: {
        sortBy: [{ id: "player", desc: false }]
      }
    },
    useSortBy
  );

  return (
    <>
      <Table
        baseClass={baseClass}
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        rows={rows}
        headerGroups={headerGroups}
        state={sortBy}
        prepareRow={prepareRow} />
      {
        rows.length < 1
          ? (
            <div className="mls-c-stats__no-results">
              <NoResults size="large" />
              <div className="mls-c-stats__no-results-text">{t("no_players_found")}</div>
              {
                emptyResultsComponent ? emptyResultsComponent : null
              }
            </div>
          )
          : <></>
      }
    </>
  );
};

export default PlayersRosterTable;
